import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

import { WithdrawalHealthCheckItem, WithdrawalHealthCheckItemsWrapper } from '../models/withdrawal-health-check';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/withdrawal-health-check`;

  getWithdrawalHealthCheckData(
    page: number,
    pageSize: number,
    sort: string | undefined,
    sortDirection: string,
    startDate: string | null,
    endDate: string | null,
  ) {
    const url = `${this.baseUrl}/list?page=${page}&pageSize=${pageSize}&sort=${sort}&sortDirection=${sortDirection}&startDate=${startDate}&endDate=${endDate}`;
    return firstValueFrom(this.http.get<WithdrawalHealthCheckItemsWrapper>(url));
  }
}
